import { createAddAll } from './add-all.js';
import last from 'it-last';
import { configure } from './lib/configure.js';
import { normaliseInput } from 'ipfs-core-utils/files/normalise-input-single';
export function createAdd(options) {
  const all = createAddAll(options);
  return configure(() => {
    async function add(input, options = {}) {
      return await last(all(normaliseInput(input), options));
    }
    return add;
  })(options);
}